// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTIVATE_ENTRY = "Aktivuj";
export const BAZAAR_NOTES_ADD_NOTE = "Pridaj pozn\u00e1mku k pou\u017e\u00edvate\u013eke...";
export const BAZAAR_NOTES_TO_NOTES = "Do pozn\u00e1mok\u2026";
export const BZ2_PRODUCT_DELETE_CONFIRM = "Naozaj chce\u0161 zmaza\u0165 tento inzer\u00e1t?";
export const CHANGE_ENTRY = "Zme\u0148";
export const DELETE_ENTRY = "Zma\u017e";
export const INACTIVATE_ENTRY = "Pozastav";
export const REPOST_ENTRY = "Aktualizuj";
export const SELLER_ACTION_BUTTONS_UNDELETE = "Obnovi\u0165";
export const SELLER_ACTION_BUTTONS_UNDELETE_CONFIRM = "Naozaj chce\u0161 obnovi\u0165 tento inzer\u00e1t?";
export const YOU_HAVE_NO_MORE_REPOSTS_SHORT = "Dnes u\u017e nem\u00e1\u0161 vo\u013en\u00e9 aktualiz\u00e1cie";
